import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

const optionalHttpUrl = z
    .string()
    .trim()
    .refine((value) => value === "" || /^https?:\/\//i.test(value), {
        message: "Enter a valid URL starting with http:// or https://",
    });

const schema = z.object({
    Name: z.string().min(1, "Name is required"),
    ShortName: z.string().optional().default(""),
    Description: z.string().optional().default(""),
    Website: optionalHttpUrl.optional().default(""),
    /** Existing remote logo URL (edit). Cleared when a new file is chosen. */
    LogoUrl: z.string().optional().default(""),
    /** Local file selected for upload — API wiring later. */
    LogoFile: z.any().nullable().optional(),
    IsActive: z.boolean().optional().default(true),
});

const newOrganizationResolver = zodResolver(schema);

export default newOrganizationResolver;
